import { render, staticRenderFns } from "./CpttEdit.vue?vue&type=template&id=e45907ec&scoped=true&"
import script from "./CpttEdit.vue?vue&type=script&lang=js&"
export * from "./CpttEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45907ec",
  null
  
)

export default component.exports